export const TAB_POSITION_CONTROL_STICKY_Z_INDEX = 50;
